import React from "react";
import { ButtonProps, IconButton, IconButtonProps, SvgIcon } from "@mui/material";

export default function PlayButton(props) {

    return(
        <IconButton {...props}>
            <SvgIcon>
            <svg width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M25.5572 15.1067L25.5578 15.107C26.354 15.6393 26.8333 16.5358 26.8333 17.5C26.8333 18.4643 26.3539 19.361 25.5594 19.8933C25.5593 19.8934 25.5591 19.8936 25.5589 19.8937L5.9449 33.0178C5.94484 33.0178 5.94477 33.0178 5.94471 33.0179C5.46492 33.3384 4.91229 33.5 4.35897 33.5C3.89535 33.5 3.43458 33.3883 3.01338 33.1612L3.01155 33.1602C2.08273 32.6611 1.5 31.6886 1.5 30.625V4.375C1.5 3.31138 2.08273 2.33886 3.01155 1.83976L3.01338 1.83877C3.43458 1.61169 3.89535 1.5 4.35897 1.5C4.91272 1.5 5.46457 1.66182 5.941 1.98109L5.94186 1.98166L25.5572 15.1067Z" stroke="#0BA9B5" strokeWidth="3"/>
            </svg>
            </SvgIcon>
        </IconButton>
    )

}